// @ts-nocheck
import React, { Component } from 'react'
import TextField from 'material-ui/TextField'
import DeleteIcon from 'material-ui/svg-icons/action/delete'

const styles = {
  contact: {
    borderTop: '1px solid #ddd',
    borderBottom: '1px solid #ddd',
    marginTop: '10px',
    paddingTop: '10px',
    paddingBottom: '20px',
    marginBottom: '20px',
    position: 'relative',
    width: '600px'
  },
  deleteIcon: {
    position: 'absolute',
    left: '580px',
    top: '40px'
  },
  textField: {
    marginRight: '10px'
  }
}

class Contact extends Component<any, any> {
  constructor (props) {
    super()
    const { addContact, contact, contactKey, handleContactDelete } = props
    let { handleContactChange } = props
    if (!handleContactChange) {
      handleContactChange = (outerKey, innerKey) => (event, key, value) => {
        let { contact } = this.state
        contact = Object.assign({}, contact, { [innerKey]: event.target.value })
        this.setState({ contact })
      }
    }
    this.state = {
      addContact,
      contact,
      contactKey,
      handleContactChange,
      handleContactDelete
    }
  }

  render () {
    const {
      contact,
      contactKey,
      handleContactDelete,
      handleContactChange
    } = this.state
    return (
      <div style={styles.contact}>
        {handleContactDelete && <div style={styles.deleteIcon}>
          <DeleteIcon onClick={handleContactDelete(contactKey)} />
        </div>}
        <TextField
          type='text'
          floatingLabelText='First Name'
          onChange={handleContactChange(contactKey, 'firstName')}
          name={contact.firstName}
          defaultValue={contact.firstName}
          style={styles.textField}
        />
        <TextField
          type='text'
          floatingLabelText='Last Name'
          onChange={handleContactChange(contactKey, 'lastName')}
          name={contact.lastName}
          defaultValue={contact.lastName}
          style={styles.textField}
        />
        <TextField
          type='email'
          floatingLabelText='Email'
          onChange={handleContactChange(contactKey, 'email')}
          name={contact.email}
          defaultValue={contact.email}
          style={styles.textField}
        />
        <TextField
          type='text'
          floatingLabelText='Title'
          onChange={handleContactChange(contactKey, 'title')}
          name={contact.title}
          defaultValue={contact.title}
          style={styles.textField}
        />
        <TextField
          type='text'
          floatingLabelText='Custom Designation'
          onChange={handleContactChange(contactKey, 'customDesignation')}
          name={contact.customDesignation}
          defaultValue={contact.customDesignation}
          style={styles.textField}
        />
        <TextField
          type='text'
          floatingLabelText='Notes'
          onChange={handleContactChange(contactKey, 'notes')}
          name={contact.notes}
          defaultValue={contact.notes}
          style={styles.textField}
        />
      </div>
    )
  }
}

export default Contact
